import { createElement } from 'react';
import { flowRight } from 'lodash';
import BaseComponent from './base';

export default (ComposedComponent, ...containers) => {
  const Comp = flowRight(containers)(ComposedComponent);

  class BaseContainer extends BaseComponent {
    render() {
      return createElement(Comp, this.props);
    }
  }

  return BaseContainer;
};
